import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  Autocomplete,
  TextField,
  TablePagination,
  Box,
  Typography,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  RadioGroup,
  FormControlLabel,
  Radio,
  DialogActions,
  Grid,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import Switch from "@mui/material/Switch";
import {
  ApiGetAllRoles,
  ApiGetAdminList,
  ApiPutUpdateAdminRole,
  ApiPutUpdateAdminStatus,
  ApiGetShoppersApplication,
  ApiPutUpdateShopperApplicationStatus,
  ApiGetDisabledTrainings,
  ApiGetPendingTrainings,
  ApiGetClientEntityByClientGroupId,
} from "../../../apiService/Core/Apicall.tsx";
import { toast } from "react-toastify";
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import dayjs, { Dayjs } from 'dayjs';
import { useSelector } from "react-redux";
import { RootState } from "../../../global/config/store.ts";
import { useDispatch } from "react-redux";
import { setSelectedClientGroup } from "../../../global/config/Reducer/clientSlice.ts";



const PendingTraining: React.FC = () => {
  const [ShopperDetails, setShopperDetails] = useState<any>([]);
  const [datalength, setdatalength] = useState<any>(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [state, setState] = useState<any>("");
  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());
  const Clientlist = useSelector((state: RootState) => state.client.clientList);
  const selectedClientName = useSelector((state: RootState) => state.client.selectedClient)
  const [selectedClient, setSelectedClient] = useState<any>(selectedClientName);
  const [clientEntityList, setClientEntityList] = useState<any>([]);
  const [clientEntityId, setClientEntityId] = useState<any>(null);

  const dispatch = useDispatch()


  useEffect(() => {
    if (selectedClient?.clientGroupName) {
      handleGetClientList()
    }
  }, [selectedClient?.clientGroupName])

  const handleGetClientList = async () => {
    const data = `?ClientGroupName=${selectedClientName?.clientGroupName}`;
    if (!selectedClient?.clientGroupName) return;
    try {
      const res: any = await ApiGetClientEntityByClientGroupId(data);
      setClientEntityList(res.data);
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await handleGetShoppers();
    };
    fetchData();
    return () => { };
  }, [rowsPerPage, page, state, selectedDate, selectedClient, clientEntityId]);



  const handleGetShoppers = async () => {
    let queryParams = `?jobMonth=${selectedDate && selectedDate?.getMonth() + 1}&jobYear=${selectedDate?.getFullYear()}&offset=${page * rowsPerPage}&limit=${rowsPerPage}&clientGroupName=${selectedClient?.clientGroupName}${clientEntityId ? `&clientEntityId=${clientEntityId}`:""}`;
    try {
      const response: any = await ApiGetPendingTrainings(queryParams);
      setdatalength(response.count);
      setShopperDetails(response.data);
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  // ------------------------------------------- Chnage Pagination -----------------------------------------------
  const handleChangePage = (_event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    setSelectedClient(selectedClientName)
  }, [selectedClientName])

  return (
    <div className="w-100 p-2">
      <Box className='bg-light p-3 border-10'>
        {/* <Grid container className='w-100 mb-4' gap={2}>
          <Grid flexDirection={{xs:"column",md:"row"}} className='mb-4 d-flex  align-items-center' gap={2} size={{ xs: 12, md: "auto" }} order={{ xs: 2, md: 1 }}>
            <FormControl size="small" sx={{ width: { xs: "100%", md: 180 }}}>
              <Autocomplete
                disablePortal
                id="mm-autocomplete"
                options={stateOptions}
                getOptionLabel={(option: any) => `${option?.label}`}
                value={stateOptions.find((option: any) => option.value === state) || null}
                onChange={(event, newValue: any) => {
                  setState(newValue?.value || null)
                }}
                defaultValue=""
                renderInput={(params) => <TextField {...params} label="Select State" />}
                size="small"
              />
            </FormControl>
            <FormControl size="small" sx={{ width: { xs: "100%", md: 180 }}}>
              <TextField sx={{
                "input": { padding: '9px' }, "& .MuiInputLabel-root": {
                  transform: "translate(14px, 10px) scale(1)",
                  "&.MuiInputLabel-shrink": {
                    transform: "translate(14px, -9px) scale(0.75)"
                  }
                }
              }} value={searchShopper} label="Search Shopper" onChange={(e) => { setsearchShopper(e.target.value) }} />
            </FormControl>
            <FormControl size="small" sx={{ width: { xs: "100%", md: 180 }}}>
              <Autocomplete
                disablePortal
                disableClearable
                id="status-autocomplete"
                options={statusOptions}
                getOptionLabel={(option: any) => option.label}
                value={statusOptions.find((option) => option.value === status) || null}
                onChange={(event, newValue: any) => setStatus(newValue?.value || "")}
                renderInput={(params) => <TextField {...params} label="Select Status" />}
                size="small"
              />
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, md: "grow" }} order={{ xs: 1, md: 2 }}>
            <Typography className="fs-42 text-center">Shopper Applications</Typography>
          </Grid>
        </Grid> */}
        <div className="d-flex align-items-center mb-5">
          <Box className='d-flex align-items-center' gap={2}>

            <FormControl size="small" className="col-md-auto col-12" sx={{ width: 180 }}>
              <Autocomplete
                disablePortal
                id="mm-autocomplete"

                options={Clientlist}
                value={selectedClient}
                getOptionLabel={(option) => option?.clientGroupName}
                isOptionEqualToValue={(option, value) =>
                  option.clientGroupDBName === value.clientGroupDBName
                }
                onChange={(event, newValue: any) => {
                  // setSelectedClient(newValue);
                  dispatch(setSelectedClientGroup(newValue))
                  // setClientId(newValue?.clientGroupName || null);
                }}

                renderInput={(params) => (
                  <TextField {...params} label="Select Client" />
                )}
                size="small"
              />
            </FormControl>
            <FormControl size="small" sx={{ width: { xs: "100%", md: 180 } }}>
              <Autocomplete
                disablePortal
                id="beacon-autocomplete"
                options={clientEntityList.filter(
                  (item:any) => item.clientEntityId !== null
                )} // filter out invalid entries
                getOptionLabel={(option) => option?.entityName || ""} // properly show label
                onChange={(event, newValue: any) => {
                  setClientEntityId(newValue?.clientEntityId || null);
                }}
                value={
                  clientEntityList.find(
                    (option:any) => option?.clientEntityId === clientEntityId
                  ) || null
                }
                // defaultValue={clientEntityList[0]?.clientEntityId}
                renderInput={(params) => (
                  <TextField {...params} label="Select Business" />
                )}
                size="small"
              />
            </FormControl>
          </Box>
          <Typography flex={1} className="fs-42 text-center">Training pending</Typography>
          <Box sx={{ alignItems: 'flex-end', marginRight: 1 }}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                views={["month", "year"]}
                label=""
                value={selectedDate}
                onChange={(newDate) => setSelectedDate(newDate)}
                format="MM/yyyy"
                sx={{
                  width: "auto",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 1,
                  }
                }}
              />
            </LocalizationProvider>
          </Box>
        </div>
        <Box className='w-100' overflow={'auto'}>
          <Table>
            <TableHead>
              <TableRow className="table-row-background">
                {[
                  "First Name",
                  "Last Name",
                  "Email",
                  "Client Group",
                  "Entity Name",
                  "Site Name",
                  "Task Date",
                ].map((item, index) => (
                  <TableCell key={index} style={{ color: "#fff" }}>
                    {item}
                  </TableCell>
                ))}
                {/* <TableCell></TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {ShopperDetails?.map((item: any) => {

                return (
                  <TableRow>
                    <TableCell>{item?.userId?.firstName}</TableCell>
                    <TableCell>{item?.userId?.lastName}</TableCell>
                    <TableCell>{item?.userId?.emailId}</TableCell>
                    <TableCell>{item?.allocationClientGroup}</TableCell>
                    <TableCell>{item?.clientEntityId?.entityName}</TableCell>
                    <TableCell>{item?.venueId?.venueName}</TableCell>
                    <TableCell>
                      {dayjs(item?.appliedAllocations?.[0]?.selectedVisitDate)?.format("DD/MM/YYYY")}
                    </TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </Box>
      </Box>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={datalength}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
};

export default PendingTraining;
